import { createFileRoute } from "@tanstack/react-router";

import PlayerStatisticsPage from "~/pages/player/PlayerStatisticsPage.tsx";

export const Route = createFileRoute("/_auth/statistics/")({
    component: PlayerStatisticsPage,
});
